// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5f68727","553":"37c8f6ac","977":"01378288"}[chunkId] + ".chunk.js";
};